"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const i18n = require("i18n");
const ui_library_1 = require("ui-library");
const types_1 = require("../types");
const BackButton = ({ onClick }) => (React.createElement(ui_library_1.Button, { color: 'flat', className: 'vf-font-bold', onClick: onClick, "data-step": types_1.Step.CHOICE_METHOD }, i18n.get('GO_BACK')));
exports.default = BackButton;
